module.exports = __webpack_public_path__ + "static/media/applause.1db54d03.mp3";